import React, { FC } from 'react';
import { FormTextAreaFieldProps } from './types';
import { FormTextArea } from './textarea';
import { FormLabel } from '../label';
import { FormError } from '../error';
import { WithStyle } from '@ch/common/utils';
import { FormTextAreaStyled, FormTextAreaWrapStyled } from './textarea.styled';

export const FormTextAreaField: FC<FormTextAreaFieldProps> & WithStyle = ({ ...props }) => {
  const { label, required, name, m, mt, mr, mb, ml, p, pt, pr, pb, pl } = props;
  return (
    <FormTextAreaWrapStyled {...{ m, mt, mr, mb, ml, p, pt, pr, pb, pl }}>
      {label && <FormLabel required={required}>{label}</FormLabel>}
      <FormTextArea {...props} />
      <FormError name={name} />
    </FormTextAreaWrapStyled>
  );
};

FormTextAreaField.defaultProps = {
  $size: 'sm',
  disabled: false,
  required: false,
  rows: 2,
  placeholder: 'Enter',
};

FormTextAreaField.displayName = 'FormTextAreaField';
FormTextAreaField.Style = FormTextAreaStyled;
